<template>
  <div
    @click="onClick"
    class="cart-icon"
    :class="computedCount > 0 ? 'not-empty' : ''"
  >
    <app-badge
      :visible="computedCount > 0"
      :content="computedCount"
      size="xs"
      variant="light"
      circle
    >
      <app-cart-nav-icon />
    </app-badge>
  </div>
</template>

<script>
import AppBadge from "@/components/ui/Badge";
import AppCartNavIcon from "@/components/ui/Icons/CartNavIcon";

export default {
  name: "AppCartIcon",
  components: {
    AppCartNavIcon,
    AppBadge,
  },
  props: {
    count: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    computedCount() {
      return this.count || null;
    },
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-icon {
  .icon {
    font-size: 1.1875rem;
  }
}
</style>
